import type { PagamentoComprovanteDespesasResponse } from "../../../services/pagamentoAvaliacaoService";
import type {
  OutraDeducao,
  PaymentDetail,
  PaymentSituation,
  TituloDeduzido,
} from "./paymentListTypes";

const labelCondicao = (item: {
  titulo?: string | null;
  codigo?: string | null;
  dias?: number | null;
}) => {
  const titulo = String(item?.titulo || "").trim();
  if (titulo) return titulo;
  const codigo = String(item?.codigo || "").trim();
  if (codigo) return codigo;
  if (item?.dias != null && Number.isFinite(Number(item.dias))) {
    return `${Number(item.dias)} dias`;
  }
  return "";
};

export function mapPagamentoComprovanteToDetail(
  raw: PagamentoComprovanteDespesasResponse | null | undefined,
  extras?: {
    situacao?: string;
    solicitacao?: number;
    ano?: number;
  },
): PaymentDetail {
  const dados = raw?.dadosPagamento ?? {};
  const sindicato = raw?.sindicato ?? {};
  const valores = raw?.valores ?? {};
  const condicoes = Array.isArray(dados.condicoesPagamento)
    ? dados.condicoesPagamento
    : [];

  const selecionada =
    condicoes.find((c) => c?.selecionado) ||
    condicoes.find((c) => Number(c?.id) === Number(dados.condicaoPagamentoId)) ||
    condicoes[0];

  const titulosDeduzidos: TituloDeduzido[] = (
    Array.isArray(raw?.titulosDeducoes) ? raw.titulosDeducoes : []
  ).map((t) => ({
    filial: t?.filial || "",
    numeroTitulo: t?.titulo || "",
    natureza: t?.natureza || "",
    emissao: t?.emitidoEm || null,
    vencimento: t?.vencimentoEm || null,
    valor: Number(t?.valor) || 0,
    historico: t?.historico || "",
    status: t?.status || "",
  }));

  const outrasDeducoes: OutraDeducao[] = (
    Array.isArray(raw?.outrasDeducoes) ? raw.outrasDeducoes : []
  ).map((o) => ({
    descricao: o?.descricao || "-",
    valor: Number(o?.valor) || 0,
  }));

  const numeroPAG = String(dados.numeroPag ?? "").trim();
  const situacao = (extras?.situacao ||
    (numeroPAG ? "Em aprovação no Fusion" : "Programação Pendente")) as PaymentSituation;

  return {
    idSolicitacao: Number(raw?.idComprovanteDespesas) || 0,
    idPagamento: Number(raw?.idPagamento) || 0,
    idComprovanteDespesas: Number(raw?.idComprovanteDespesas) || 0,
    ano: Number(extras?.ano) || 0,
    cnpj: sindicato.cnpj || "",
    sigla: sindicato.sigla || "",
    nomeSindicato: sindicato.nome || "",
    situacaoPagamento: situacao,
    solicitacao: Number(extras?.solicitacao) || 0,
    valorBrutoApoio: Number(valores.valorBruto) || 0,
    valorDeducoes: Number(valores.valorDeducoes) || 0,
    valorLiquido: Number(valores.valorTotalLiquido) || 0,
    titulosDeduzidos,
    outrasDeducoes,
    descricao: dados.descricao || "",
    dataEmissao: dados.emitidoEm || null,
    dataVencimento: dados.vencimentoEm || null,
    numeroPAG,
    dataAprovacaoPAG: dados.aprovadoEm || null,
    numeroTitulo: dados.numeroTitulo || "",
    condicaoPagamento: labelCondicao(selecionada || {}),
    condicaoPagamentoId: Number(dados.condicaoPagamentoId || selecionada?.id) || 0,
    condicoesPagamento: condicoes.map((c) => ({
      id: Number(c?.id) || 0,
      titulo: labelCondicao(c),
      codigo: c?.codigo || "",
      dias: Number(c?.dias) || 0,
      selected: !!c?.selecionado,
      selecionado: !!c?.selecionado,
    })),
  };
}
